export default __webpack_public_path__ + "static/media/smallTopbarIcon.0f6ae9de.svg";